function submit_validated_form(form, options={}){
    if(!options.s_snackbar)
        options.s_snackbar = { show: true, timer: 4000 }; 
    if(!options.f_snackbar)
        options.f_snackbar = { show: true, timer: 4000 };

    show_loading_svg();

    if(typeof form == 'string')
        var form = document.getElementById(form);

    var url = form.getAttribute('action');
    const data = new FormData(form);

    am.$.ajax({
        type: 'POST',
        url: url,
        data: data,
        processData: false,
        contentType: false,
        success: (res) => {
            var parsed = JSON.parse(res);
            let show_close = false; 
            
            if(parsed.status == 200){
                if(options.s_snackbar.show && parsed.message){
                    show_close = checkSnackbarShowClose(parsed.message);
                    show_snackbar({
                        // Server flash message: may be HTML and may embed user data — sanitize.
                        message: sanitize_notification_html(parsed.message),
                        html: true,
                        type: 'success',
                        timer: options.s_snackbar.timer,
                        show_close: show_close
                    });
                }
    
                if(options.s_cb){
                    options.s_cb.each((cb) => {
                        cb(parsed);
                    })
                }
            }
            else if(parsed.status == 400){
                if(options.f_snackbar.show && parsed.message){
                    show_close = checkSnackbarShowClose(parsed.message);

                    show_snackbar({
                        // Server flash message: may be HTML and may embed user data — sanitize.
                        message: sanitize_notification_html(parsed.message),
                        html: true,
                        type: 'danger',
                        timer: options.f_snackbar.timer,
                        show_close: show_close
                    });
                }
    
                if(options.f_cb){
                    options.f_cb.each((cb) => {
                        cb(parsed);
                    })
                }
            }
        },
        error: (res) => { 
            var parsed = JSON.parsed(res);
            
            if(options.f_snackbar.show && parsed.message){
                let show_close = false; 
                    show_close = checkSnackbarShowClose(parsed.message);

                show_snackbar({
                    // Server flash message: may be HTML and may embed user data — sanitize.
                    message: sanitize_notification_html(parsed.message),
                    html: true,
                    type: 'danger',
                    timer: options.f_snackbar.timer,
                    show_close: true
                });
            }

            if(options.f_cb){
                options.f_cb.each((cb) => {
                    cb(parsed);
                })
            }

        },
        complete: () => { hide_loading_svg(); }
    });
}